import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { CoreRoutingModule } from './core.routing.module';
import { SharedModule } from '../shared/shared.module';

import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LayoutComponent } from './components/layout/layout.component';
import { SelectDomainComponent } from './pages/select-domain/select-domain.component';
import { SetupMultiFactorPage } from './pages/setup-multi-factor/setup-multi-factor.page';

import { AuthService } from './services/auth.service';
import { CustomerService } from './services/customer.service';
import { CommentService } from './services/comment.service';
import { DomainService } from './services/domain.service';
import { RiskAssessmentService } from './services/risk-assessment.service';
import { AdminService } from './services/admin.service';
import { OwnRestrictedListService } from './services/own-restricted-list.service';
import { RecordService } from './services/record.service';
import { DocumentsService } from './services/documents.service';
import { ScreeningService } from './services/screening.service';
import { NotFoundComponent } from './pages/not-found/not-found.component';

import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SelectDomainPopupComponent } from './components/select-domain-popup/select-domain-popup.component';
import { CrpService } from './services/crp.service';
import { IdleService } from './services/idle.service';


const SERVICES = [
  AdminService,
  AuthService,
  CommentService,
  CustomerService,
  DocumentsService,
  DomainService,
  OwnRestrictedListService,
  RecordService,
  RiskAssessmentService,
  ScreeningService,
  CrpService,
  IdleService
];

@NgModule({
  imports: [
    ScrollingModule,
    CoreRoutingModule,
    SharedModule
  ],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    SelectDomainComponent,
    NotFoundComponent,
    SetupMultiFactorPage,

    LayoutComponent,
    HeaderComponent,
    SidebarComponent,
    SelectDomainPopupComponent
  ],
  entryComponents: [
    SelectDomainPopupComponent
  ]
})
export class CoreModule {
  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        ...SERVICES
      ]
    };
  }
}
